/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, colors, spacing, zindex } from '@chegg-ui/theme';
import styled, { css } from 'styled-components';
// This wrapper is to handle safari issue
// safari expose area equal to box shadow where inner li element trigger mouse events outside parent UL.
export var ListboxContainer = styled.div.withConfig({
  componentId: "qq69hw-0"
})(["box-shadow:0 0 16px rgba(34,34,34,0.24);border:", ";z-index:", ";border-radius:", ";", ";", ";position:", ";", ""], function (_ref) {
  var customTheme = _ref.customTheme;
  return customTheme.listBoxBorder;
}, zindex.dropdown, function (_ref2) {
  var customTheme = _ref2.customTheme;
  return customTheme.listBoxBorderRadius;
}, function (_ref3) {
  var dropup = _ref3.dropup;
  return dropup ? "\n    bottom: 100%;\n  " : "\n    top: 100%;\n  ";
}, function (_ref4) {
  var isOpen = _ref4.isOpen;
  return !isOpen && "\n     display: none;\n  ";
}, function (_ref5) {
  var container = _ref5.container;
  return container ? 'fixed' : 'absolute';
}, function (_ref6) {
  var rendererBoundingRect = _ref6.rendererBoundingRect,
      dropup = _ref6.dropup,
      listboxHeight = _ref6.listboxHeight,
      customTheme = _ref6.customTheme;
  return rendererBoundingRect ? css(["width:", "px;left:", "px;top:", "px;"], rendererBoundingRect.width, rendererBoundingRect.left, dropup ? "".concat(rendererBoundingRect.top - listboxHeight + customTheme.listBoxContainerPositionTop) : "".concat(rendererBoundingRect.top + rendererBoundingRect.height + customTheme.listBoxContainerPositionTop)) : css(["left:0;right:0;", ""], dropup ? "bottom: 100%;" : "top: 100%;");
});
export var ListboxOptions = styled.ul.withConfig({
  componentId: "qq69hw-1"
})(["font-family:", ";color:", ";font-size:inherit;background-color:", ";outline:0px;height:auto;max-height:", ";margin:0;padding:0;overflow-y:auto;list-style-type:none;border-radius:", ";"], font.family["default"], function (_ref7) {
  var customTheme = _ref7.customTheme;
  return customTheme.listboxOptionsTextColor;
}, colors.white, function (_ref8) {
  var maxHeight = _ref8.maxHeight;
  return maxHeight;
}, function (_ref9) {
  var customTheme = _ref9.customTheme;
  return customTheme.listBoxBorderRadius;
});
export var ListboxItem = styled.li.withConfig({
  componentId: "qq69hw-2"
})(["position:relative;cursor:pointer;display:block;line-height:", ";font-size:", ";padding:", " ", ";white-space:normal;overflow:initial;text-overflow:initial;outline:0px;box-shadow:none;border-bottom:", ";border-top:", ";&:hover{background:", ";color:", ";border-bottom:", ";border-top:", ";}", ";", " ", ""], function (_ref10) {
  var customTheme = _ref10.customTheme;
  return customTheme.lineHeight;
}, function (_ref11) {
  var customTheme = _ref11.customTheme;
  return customTheme.listItemFontSize;
}, spacing.px12, spacing.px16, function (_ref12) {
  var customTheme = _ref12.customTheme;
  return customTheme.listItemDefaultBorder;
}, function (_ref13) {
  var customTheme = _ref13.customTheme;
  return customTheme.listItemDefaultBorder;
}, function (_ref14) {
  var customTheme = _ref14.customTheme;
  return customTheme.listItemHoverBackgroundColor;
}, function (_ref15) {
  var customTheme = _ref15.customTheme;
  return customTheme.listItemHoverTextColor;
}, function (_ref16) {
  var customTheme = _ref16.customTheme;
  return customTheme.listItemHoverBorder;
}, function (_ref17) {
  var customTheme = _ref17.customTheme;
  return customTheme.listItemHoverBorder;
}, function (_ref18) {
  var isKeyboardHover = _ref18.isKeyboardHover,
      isFocused = _ref18.isFocused,
      customTheme = _ref18.customTheme;
  return isFocused && isKeyboardHover && "\n    background: ".concat(customTheme.listItemHoverBackgroundColor, ";\n    color: ").concat(customTheme.listItemHoverTextColor, ";\n    border-bottom: ").concat(customTheme.listItemHoverBorder, ";\n    border-top: ").concat(customTheme.listItemHoverBorder, ";\n  ");
}, function (_ref19) {
  var isKeyboardHover = _ref19.isKeyboardHover,
      isFocused = _ref19.isFocused;
  return isKeyboardHover && !isFocused && "\n    &:hover {\n      background: inherit;\n      color: inherit;\n      box-shadow: inherit;\n    }\n  ";
}, function (_ref20) {
  var isSelected = _ref20.isSelected,
      customTheme = _ref20.customTheme;
  return isSelected && "\n    background: ".concat(customTheme.listItemSelectedBackgroundColor, ";\n    color: ").concat(customTheme.listItemSelectedTextColor, ";\n    box-shadow: none;\n    padding-right: ").concat(spacing.px40, ";\n    border-bottom: ").concat(customTheme.listItemDefaultBorder, ";\n    border-top: ").concat(customTheme.listItemDefaultBorder, ";\n    ");
});
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        listItemFontSize: theme.font.size.xs,
        listItemSelectedBackgroundColor: colors.violet050,
        listItemHoverTextColor: theme.colors.border.dark,
        listItemSelectedTextColor: colors.violet900,
        checkmarkIconColor: colors.violet900,
        lineHeight: theme.font.lineHeight.sm,
        listItemHoverBackgroundColor: colors.grey050,
        listItemHoverBorder: "1px solid ".concat(colors.grey600),
        listItemDefaultBorder: "1px solid transparent",
        showHorizonIcon: true,
        listBoxContainerPositionTop: 4,
        listBoxBorderRadius: theme.radius.sm,
        listBoxBorder: "1px solid ".concat(colors.grey300),
        listboxOptionsTextColor: theme.colors.border.dark900
      };
    },
    fanta: {
      listItemFontSize: font.size.px18,
      listItemHoverBackgroundColor: colors.dark,
      listItemSelectedBackgroundColor: colors.skyLight,
      listItemSelectedTextColor: colors.dark,
      checkmarkIconColor: colors.dark,
      lineHeight: font.lineHeight.xs,
      listItemHoverBorder: 'none',
      listItemDefaultBorder: 'none',
      listItemHoverTextColor: colors.white,
      showHorizonIcon: false,
      listBoxContainerPositionTop: 0,
      listBoxBorderRadius: '0',
      listBoxBorder: 'none',
      listboxOptionsTextColor: colors.dark
    },
    prop: themeProp
  };
};
export var CheckmarkIconPositioner = styled.div.withConfig({
  componentId: "qq69hw-3"
})(["top:50%;position:absolute;transform:translateY(-50%);height:", ";color:", ";right:", ";", ":hover &{color:", ";}"], spacing.px24, function (_ref21) {
  var customTheme = _ref21.customTheme;
  return customTheme.checkmarkIconColor;
}, spacing.px16, ListboxItem, function (_ref22) {
  var customTheme = _ref22.customTheme;
  return customTheme.listItemHoverTextColor;
});